import React from 'react'
import getConfig from 'next/config'

import lang from 'lang'

const { publicRuntimeConfig } = getConfig()

interface Props {
  title: string
  src: string
}

class IframeModal extends React.Component<Props> {
  renderIFrame(): React.ReactNode {
    return (
      <iframe
        title={this.props.title}
        src={this.props.src}
        width="100%"
        height="540"
        frameBorder="0"
        className="gfiframe"
      />
    )
  }

  renderIFramePlaceholder(): React.ReactNode {
    return (
      <div className="iframe-placeholder">
        {lang.iframePlaceholder}
        {this.props.src}
      </div>
    )
  }

  render(): React.ReactNode {
    return (
      <div className="modal-wrapper">
        <div className="modal-container">
          {publicRuntimeConfig.SERVER_ENV === 'production'
            ? this.renderIFrame()
            : this.renderIFramePlaceholder()}
        </div>
      </div>
    )
  }
}

export default IframeModal
